
export default function VantaggiSections() {
  const vantaggi = [
    {
      numero: "01",
      titolo: "Accesso a Nuove Fonti di Finanziamento",
      descrizione: "Un brand valorizzato diventa un asset tangibile che può essere utilizzato come garanzia per ottenere finanziamenti bancari a condizioni più favorevoli.",
      icon: "ri-bank-line",
      color: "from-[#E879F9] to-[#22C55E]",
      benefits: [
        "Migliori condizioni di credito",
        "Maggiore capacità di indebitamento",
        "Riduzione dei tassi di interesse",
        "Accesso a linee di credito dedicate"
      ]
    },
    {
      numero: "02",
      titolo: "Valorizzazione in Operazioni M&A",
      descrizione: "In caso di fusioni, acquisizioni o cessioni aziendali, un brand valorizzato aumenta significativamente il valore complessivo dell'operazione.",
      icon: "ri-exchange-line",
      color: "from-[#22C55E] to-[#E879F9]",
      benefits: [
        "Aumento del prezzo di vendita",
        "Maggiore attrattività per investitori",
        "Negoziazione da posizione di forza",
        "Valutazione oggettiva e certificata"
      ]
    },
    {
      numero: "03",
      titolo: "Protezione Legale e Proprietà Intellettuale",
      descrizione: "La valorizzazione formale del brand rafforza la tutela legale e facilita la difesa in caso di controversie o contraffazioni.",
      icon: "ri-shield-check-line",
      color: "from-[#E879F9] to-[#22C55E]",
      benefits: [
        "Tutela rafforzata del marchio",
        "Difesa più efficace in tribunale",
        "Deterrente contro contraffazioni",
        "Documentazione certificata del valore"
      ]
    },
    {
      numero: "04",
      titolo: "Ottimizzazione Fiscale",
      descrizione: "Un brand valorizzato correttamente può generare benefici fiscali attraverso l'ammortamento e la deducibilità delle royalty.",
      icon: "ri-file-chart-line",
      color: "from-[#22C55E] to-[#E879F9]",
      benefits: [
        "Ammortamento del valore del brand",
        "Deducibilità delle royalty",
        "Ottimizzazione del carico fiscale",
        "Pianificazione fiscale strategica"
      ]
    },
    {
      numero: "05",
      titolo: "Attrazione di Investitori e Partner",
      descrizione: "Un brand con valore certificato è più attraente per investitori, venture capital e potenziali partner strategici.",
      icon: "ri-team-line",
      color: "from-[#E879F9] to-[#22C55E]",
      benefits: [
        "Maggiore credibilità verso investitori",
        "Facilitazione di partnership strategiche",
        "Accesso a round di finanziamento",
        "Valutazione pre-money più elevata"
      ]
    },
    {
      numero: "06",
      titolo: "Gestione Strategica del Brand",
      descrizione: "La valorizzazione fornisce metriche concrete per monitorare e ottimizzare le performance del brand nel tempo.",
      icon: "ri-line-chart-line",
      color: "from-[#22C55E] to-[#E879F9]",
      benefits: [
        "KPI chiari e misurabili",
        "Monitoraggio dell'evoluzione del valore",
        "Decisioni basate su dati oggettivi",
        "ROI delle attività di marketing"
      ]
    },
    {
      numero: "07",
      titolo: "Vantaggio Competitivo",
      descrizione: "Un brand valorizzato comunica solidità e professionalità, differenziandoti dalla concorrenza e rafforzando la posizione di mercato.",
      icon: "ri-trophy-line",
      color: "from-[#E879F9] to-[#22C55E]",
      benefits: [
        "Differenziazione dalla concorrenza",
        "Percezione di maggiore affidabilità",
        "Posizionamento premium",
        "Barriera all'ingresso per competitor"
      ]
    },
    {
      numero: "08",
      titolo: "Patrimonializzazione dell'Azienda",
      descrizione: "Il brand valorizzato entra nel patrimonio aziendale come asset intangibile, aumentando il valore complessivo dell'impresa.",
      icon: "ri-safe-line",
      color: "from-[#22C55E] to-[#E879F9]",
      benefits: [
        "Incremento del patrimonio netto",
        "Miglioramento degli indici di bilancio",
        "Solidità patrimoniale certificata",
        "Asset utilizzabile come garanzia"
      ]
    },
    {
      numero: "09",
      titolo: "Generazione di Royalty",
      descrizione: "Un brand valorizzato può essere concesso in licenza generando flussi di royalty costanti e prevedibili.",
      icon: "ri-money-euro-circle-line",
      color: "from-[#E879F9] to-[#22C55E]",
      benefits: [
        "Nuove fonti di ricavo ricorrenti",
        "Espansione senza investimenti diretti",
        "Monetizzazione del brand",
        "Diversificazione dei ricavi"
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#E879F9]/10 to-[#22C55E]/10 border border-[#E879F9]/30 rounded-full text-sm font-semibold text-slate-800 mb-6">
            <i className="ri-star-line text-[#E879F9] mr-2"></i>
            9 Vantaggi Strategici
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            I Vantaggi della
            <span className="block mt-2 bg-gradient-to-r from-[#E879F9] to-[#22C55E] bg-clip-text text-transparent">
              Valorizzazione del Brand
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Scopri come la valorizzazione professionale del tuo brand può trasformare 
            la tua azienda e generare opportunità concrete di crescita
          </p>
        </div>

        {/* Vantaggi Grid */}
        <div className="space-y-8">
          {vantaggi.map((vantaggio, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl p-8 md:p-10 border border-slate-200 shadow-lg hover:shadow-2xl hover:border-[#E879F9]/30 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="flex flex-col lg:flex-row gap-8 items-start">
                {/* Left Side - Number & Icon */}
                <div className="flex-shrink-0">
                  <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${vantaggio.color} flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 group-hover:shadow-xl transition-all duration-300`}>
                    <i className={`${vantaggio.icon} text-3xl text-white`}></i>
                  </div>
                  <div className={`text-6xl font-bold bg-gradient-to-br ${vantaggio.color} bg-clip-text text-transparent opacity-20 group-hover:opacity-30 transition-opacity duration-300`}>
                    {vantaggio.numero}
                  </div>
                </div>

                {/* Right Side - Content */}
                <div className="flex-1">
                  <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4 group-hover:text-[#E879F9] transition-colors duration-300">
                    {vantaggio.titolo}
                  </h3>
                  <p className="text-lg text-slate-600 mb-6 leading-relaxed">
                    {vantaggio.descrizione}
                  </p>

                  {/* Benefits List */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {vantaggio.benefits.map((benefit, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <div className={`w-6 h-6 rounded-full bg-gradient-to-br ${vantaggio.color} flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm`}>
                          <i className="ri-check-line text-white text-sm"></i>
                        </div>
                        <span className="text-slate-700 font-medium">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-20 text-center">
          <div className="bg-gradient-to-br from-slate-50 to-white rounded-3xl p-12 border border-slate-200 shadow-xl">
            <div className="max-w-3xl mx-auto">
              <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#E879F9] to-[#22C55E] flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-rocket-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Pronto a Valorizzare il Tuo Brand?
              </h3>
              <p className="text-xl text-slate-600 mb-8">
                Inizia oggi il percorso di valorizzazione e scopri il vero potenziale del tuo brand
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/contatti')}
                  className="group px-8 py-4 bg-gradient-to-r from-[#E879F9] to-[#22C55E] text-white rounded-full font-semibold text-lg shadow-xl shadow-[#E879F9]/25 hover:shadow-2xl hover:shadow-[#E879F9]/35 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Richiedi Analisi Gratuita
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                </button>
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/bci')}
                  className="px-8 py-4 bg-white text-slate-800 rounded-full font-semibold text-lg border-2 border-slate-200 hover:border-[#E879F9] hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Scopri il Metodo BCI
                  <i className="ri-compass-line ml-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
